document.addEventListener('DOMContentLoaded', function () {
  // 新增：终极 iOS 滚动锁定方案
  let scrollPosition = 0;
  function lockBodyScroll() {
    // 记录打开抽屉前，页面滚动到了哪里
    scrollPosition = window.scrollY || window.pageYOffset;
    // 强行固定 body
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.overscrollBehavior = 'none';
  }

  function unlockBodyScroll() {
    // 恢复 body 原本的属性
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overscroll-behavior');
    // 瞬间滚回打开抽屉前的位置，视觉上完全无缝
    window.scrollTo(0, scrollPosition);
  }
  // --- 1. 获取 DOM 元素与服务端上下文 ---
  const $tagDropdown = document.getElementById('x-media-tag-dropdown');
  const $tagTrigger = document.getElementById('x-media-tag-trigger');
  const $searchForm = document.getElementById('x-media-ajax-search');
  const $searchInput = document.getElementById('x-media-search-input');
  const $grid = document.getElementById('x-media-grid');
  const $loadBtnWrap = document.querySelector('.x-media-load-more-wrap');
  const $loadBtn = document.getElementById('x-media-load-btn');
  const $selectedTag = $tagDropdown.querySelectorAll('.x-media-option.is-selected');
  // mobile search dom
  const $mobileTrigger = document.getElementById('x-media-mobile-search-trigger');
  const $drawer = document.getElementById('x-media-search-drawer');
  const $drawerClose = document.getElementById('x-media-drawer-close');
  const $mobileSearchForm = document.getElementById('x-media-mobile-search-form');
  const $mobileSearchInput = document.getElementById('x-media-mobile-search-input');
  const $historyTagsContainer = document.getElementById('x-media-history-tags');
  const $clearHistoryBtn = document.getElementById('x-media-clear-history');

  // 获取当前所处的 Tag 分类和博客句柄
  const currentTag = window.MEDIA_ROOM_CONSTANTS.currentTag;
  const blogHandle = window.MEDIA_ROOM_CONSTANTS.blogHandle;

  // --- 2. XSS 终极防御：HTML 转义函数 ---
  function sanitizeHTML(str) {
    if (!str) return '';
    return str.replace(/[&<>'"]/g, function (tag) {
      const charsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;',
      };
      return charsToReplace[tag] || tag;
    });
  }

  // --- 3. 核心功能：执行搜索并局部更新页面 ---
  function executeSearch(keyword, shouldPushState = true) {
    const cleanKeyword = sanitizeHTML(keyword.trim());

    // 场景 A：清空了搜索词 -> 重置回默认类别列表
    if (!cleanKeyword) {
      if (shouldPushState) {
        const newUrl = new URL(window.location);
        newUrl.searchParams.delete('q');
        window.location.href = newUrl.toString(); // 刷新回到该类别的无搜索状态
      }
      return;
    }

    // 场景 B：执行搜索 -> 更新 URL (History API 状态持久化)
    if (shouldPushState) {
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('q', cleanKeyword);
      window.history.pushState({ path: newUrl.toString() }, '', newUrl.toString());
    }

    // 更新输入框和视觉 loading 状态
    $searchInput.value = cleanKeyword;
    if ($loadBtnWrap) $loadBtnWrap.style.display = 'none';

    const featuredArticleUrl = window.MEDIA_ROOM_CONSTANTS.featuredArticleUrl;
    // 如果有关键词，进入搜索模式，隐藏大图置顶
    if (cleanKeyword) {
      document.body.classList.add('x-media-is-searching');
    } else {
      document.body.classList.remove('x-media-is-searching');
    }
    // 构建标准的 Shopify 搜索语法：仅限定关键字和 Tag
    // (注意：这里抛弃了无法识别的 blog: 修饰符)
    let apiQuery = cleanKeyword;

    xUtils.showLoading();
    // 请求备用模板，返回纯正的 HTML Fragment
    fetch(`/search?type=article&q=${encodeURIComponent(apiQuery)}&view=media-ajax`)
      .then((response) => response.text())
      .then((html) => {
        // 将返回的 HTML 字符串转化为真实的 DOM 节点
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const $cards = doc.querySelectorAll('.x-media-room-card');

        $grid.innerHTML = '';
        let matchCount = 0;
        const currentTagLower = currentTag ? currentTag.toLowerCase() : '';

        // 客户端进行 Blog 维度的二次严格过滤
        // 因为 /search API 会搜出全站所有带该 Tag 的文章，我们要确保只展示 Media Room 里的
        $cards.forEach(($card) => {
          const cardUrl = $card.querySelector('.x-media-card-title a')?.getAttribute('href');
          if (cardUrl === featuredArticleUrl) {
            $card.classList.add('is-featured-duplicate');
          }
          const cardBlog = $card.getAttribute('data-blog-handle');
          const cardTags = $card.getAttribute('data-tags') || '';
          const tagsArray = cardTags.split(','); // 转成数组以防部分匹配 (如 "roadster" 匹配了 "road")

          // 拦截器 1：必须属于当前 Blog (Media Room)
          if (cardBlog === blogHandle) {
            // 拦截器 2：如果没有选中特定 Tag（即 All Topics），或者该卡片的标签包含了当前选中的 Tag
            if (!currentTagLower || tagsArray.includes(currentTagLower)) {
              $grid.appendChild($card);
              matchCount++;
            }
          }
        });

        // 如果没有符合该 Blog 的文章
        if (matchCount === 0) {
          $grid.innerHTML = `<p style="text-align: center; grid-column: 1 / -1; padding: 50px 0;">No articles found for "${cleanKeyword}".</p>`;
        }
      })
      .catch((error) => {
        console.error('Search Error:', error);
        $grid.innerHTML =
          '<p style="text-align: center; grid-column: 1 / -1;">Error fetching results.</p>';
      })
      .finally(() => {
        $grid.style.visibility = 'visible';
        xUtils.hideLoading();
      });
  }

  // --- 3.5. 搜索历史记录与移动端搜索处理 ---
  const HISTORY_KEY = 'x_media_search_history';

  // 获取本地记录
  function getHistory() {
    return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
  }

  // 保存记录并去重（最多保留 10 条）
  function saveHistory(keyword) {
    if (!keyword.trim()) return;
    let history = getHistory();
    history = history.filter((item) => item !== keyword.trim());
    history.unshift(keyword.trim());
    if (history.length > 10) history = history.slice(0, 10);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  }

  // 清除记录
  function clearHistory() {
    localStorage.removeItem(HISTORY_KEY);
    renderHistory();
  }

  // 渲染历史记录胶囊
  function renderHistory() {
    if (!$historyTagsContainer) return;
    const history = getHistory();
    $historyTagsContainer.innerHTML = '';

    if (history.length === 0) {
      $historyTagsContainer.innerHTML =
        '<span style="font-size:14px; color:#999;">No history</span>';
      return;
    }

    history.forEach((keyword) => {
      const $tag = document.createElement('button');
      $tag.type = 'button';
      $tag.className = 'x-media-history-tag';
      $tag.innerText = keyword;

      // 点击历史记录时，直接触发搜索
      $tag.addEventListener('click', () => {
        if ($mobileSearchInput) $mobileSearchInput.value = keyword;
        if ($searchInput) $searchInput.value = keyword; // 同步给桌面端
        handleSearchSubmit(keyword);
      });
      $historyTagsContainer.appendChild($tag);
    });
  }

  // 统一的搜索提交入口（处理本地缓存并关闭抽屉）
  function handleSearchSubmit(keyword) {
    saveHistory(keyword);
    renderHistory();
    executeSearch(keyword, true);

    // 如果抽屉处于打开状态，执行搜索后将其关闭
    if ($drawer && $drawer.classList.contains('is-active')) {
      $drawer.classList.remove('is-active');
      unlockBodyScroll(); // 恢复底部页面滚动
    }
  }

  // --- 4. 绑定各类交互事件 ---

  // A. 定制下拉模态框展开/收起
  if ($tagDropdown && $tagTrigger) {
    $tagTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      $tagDropdown.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!$tagDropdown.contains(e.target)) {
        $tagDropdown.classList.remove('is-open');
      }
    });
  }

  // B. AJAX 异步无缝加载下一页
  if ($loadBtn && $grid) {
    $loadBtn.addEventListener('click', function () {
      const nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl) return;

      xUtils.showLoading();
      this.disabled = true;

      const featuredArticleUrl = window.MEDIA_ROOM_CONSTANTS.featuredArticleUrl;
      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newCards = doc.querySelectorAll('.x-media-room-card');
          newCards.forEach(($card) => {
            const cardUrl = $card.querySelector('.x-media-card-title a')?.getAttribute('href');
            if (cardUrl === featuredArticleUrl) {
              $card.classList.add('is-featured-duplicate');
            }

            $grid.appendChild($card);
          });

          const $newBtn = doc.getElementById('x-media-load-btn');
          if ($newBtn && $newBtn.getAttribute('data-next-url')) {
            this.setAttribute('data-next-url', $newBtn.getAttribute('data-next-url'));
            this.disabled = false;
          } else {
            this.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more articles:', error);
        })
        .finally(() => {
          xUtils.hideLoading();
          this.disabled = false;
        });
    });
  }

  // C. 拦截搜索提交事件
  if ($searchForm && $searchInput) {
    $searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      handleSearchSubmit($searchInput.value);
    });
  }

  // 移动端表单提交
  if ($mobileSearchForm && $mobileSearchInput) {
    $mobileSearchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      handleSearchSubmit($mobileSearchInput.value);
    });
  }

  // D. 移动端抽屉唤醒与关闭控制
  if ($mobileTrigger && $drawer) {
    $mobileTrigger.addEventListener('click', () => {
      $drawer.classList.add('is-active');
      lockBodyScroll(); // 阻止底部页面滚动穿透
      renderHistory(); // 展开时拉取最新记录
      setTimeout(() => $mobileSearchInput.focus(), 350); // 滑动结束后自动聚焦输入框
    });
  }

  if ($drawerClose && $drawer) {
    $drawerClose.addEventListener('click', () => {
      $drawer.classList.remove('is-active');
      unlockBodyScroll();
    });
  }
  // 抽屉内的右滑关闭手势监听
  let touchStartX = 0;
  let touchStartY = 0;

  if ($drawer) {
    // 1. 记录手指按下的起点坐标
    $drawer.addEventListener(
      'touchstart',
      function (e) {
        // 推荐使用 clientX，它代表相对于浏览器可视区域的坐标
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;

        // 👇 核心修复：如果手指落在屏幕最左侧 30px 的“系统手势死区”
        if (touchStartX < 30) {
          if (!e.target.closest('.x-media-drawer-close')) {
            e.preventDefault(); // 强行拦截并扼杀浏览器的原生返回手势
          }
        }
      },
      { passive: false }
    );

    // 2. 记录手指离开的终点坐标，并计算轨迹（这部分逻辑不需要变）
    $drawer.addEventListener(
      'touchend',
      function (e) {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;

        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;

        if (deltaX > 60 && Math.abs(deltaX) > Math.abs(deltaY)) {
          $drawer.classList.remove('is-active');
          unlockBodyScroll();
          if ($mobileSearchInput) $mobileSearchInput.blur();
        }
      },
      { passive: true }
    );
  }

  // E. 清除历史记录
  if ($clearHistoryBtn) {
    $clearHistoryBtn.addEventListener('click', clearHistory);
  }

  // F. 页面初始化探测 (State Hydration)
  const urlParams = new URLSearchParams(window.location.search);
  const initialQuery = urlParams.get('q');
  if (initialQuery) {
    executeSearch(initialQuery, false);
  } else {
    $grid.style.visibility = 'visible';
  }

  // --- 5. 移动端吸顶逻辑 (DOM Teleport) ---
  const $stickyHeader = document.getElementById('x-media-sticky-header');
  const $sentinel = document.getElementById('x-media-sticky-sentinel');
  const $controlsWrapper = document.getElementById('x-media-controls');
  const $originalPlaceholder = document.getElementById('x-media-original-controls-placeholder');
  const $stickyDestination = document.getElementById('x-media-sticky-controls-destination');

  if ($stickyHeader && $sentinel && $controlsWrapper && $originalPlaceholder) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 如果是桌面端，不执行吸顶传送逻辑
          if (window.innerWidth > 768) return;

          // 当 sentinel (哨兵) 离开视口顶部时（意味着页面向下滚动过了控制栏）
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            // 1. 瞬间锁定原占位符的高度，防止底下的内容突然往上跳（防止布局抖动）
            $originalPlaceholder.style.height = `${$controlsWrapper.offsetHeight}px`;
            // 2. 将控制栏 DOM 原封不动地转移到吸顶区域
            $stickyDestination.appendChild($controlsWrapper);
            // 3. 展现吸顶模块
            $stickyHeader.classList.add('is-visible');
          } else {
            // 当页面向上滚动，哨兵重新回到视口内时
            if ($stickyDestination.contains($controlsWrapper)) {
              // 1. 传送回原处
              $originalPlaceholder.appendChild($controlsWrapper);
            }
            // 2. 释放高度限制并隐藏吸顶模块
            $originalPlaceholder.style.height = 'auto';
            $stickyHeader.classList.remove('is-visible');
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0,
      }
    );

    observer.observe($sentinel);

    // 健壮性保障：如果用户在打开吸顶的情况下突然把浏览器拉宽（从手机切到PC）
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768 && $stickyDestination.contains($controlsWrapper)) {
        $originalPlaceholder.appendChild($controlsWrapper);
        $originalPlaceholder.style.height = 'auto';
        $stickyHeader.classList.remove('is-visible');
      }
    });
  }
});
